/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_TitleInputs */

const en_jobs_title = /** @type {(inputs: Jobs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recurring jobs`)
};

const he_jobs_title = /** @type {(inputs: Jobs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`משימות חוזרות`)
};

/**
* | output |
* | --- |
* | "Recurring jobs" |
*
* @param {Jobs_TitleInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const jobs_title = /** @type {((inputs?: Jobs_TitleInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_TitleInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_title(inputs)
	return he_jobs_title(inputs)
});